@if(isOpen){
<div class="overlay" *ngIf="!isChildPopupOpened">
    &nbsp;
</div>
<div class="bill-staff-box-wrapper center-full"
    [ngClass]="isChildPopupOpened ? 'bill-staff-box-wrapper-closed ' : 'bill-staff-box-wrapper-opened'">
    <ngb-toast [header]="header" [autohide]="false" (hidden)="onAction(1)">
        <div class="row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.billing.created_by" />
                <span [ngClass]="localService.getLanguageCode(createdByLanguage)">{{createdByName}}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.billing.staff" />
                <div>
                    <app-business-relationship [id]="elementIds.brn" [isMultiCustomerTypes]="true"
                        [businessId]="businessId" [isReadOnly]="isReadOnly" [currentUserId]="staffId"
                        (onUserUpdated)="onUserUpdated($event,1)" [relationShipType]="2"
                        (OnPopupOpenedChanged)="isChildPopupOpened = $event"
                        [relationShipRole]="3"></app-business-relationship>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="!isReadOnly">
            <div class="col-6">
            </div>
            <div class="col-6" style="text-align: right;">
                <button type="button" class="btn btn-primary"
                    (click)="onAction(2)">{{localService.languageContent.common.save}}</button>
            </div>
        </div>
    </ngb-toast>
</div>
}